import * as React from 'react';
import { Helmet } from 'react-helmet';

function Head({ pageTitle, site }) {
  return (
    <Helmet htmlAttributes={{ lang: process.env.GATSBY_USER_LOCALE }}>
      <title>{`${pageTitle} - ${site.title}`}</title>
      {site.description ? (
        <meta name="description" content={site.description} />
      ) : (
        ''
      )}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={`${pageTitle} - ${site.title}`} />
      {site.description ? (
        <meta property="og:description" content={site.description} />
      ) : (
        ''
      )}
      <meta property="og:image" content={site.logo.url} />
      <meta property="og:url" content={`https://${site.url}`} />
      <meta property="og:site_name" content={site.title} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={`https://${site.url}`} />
      <meta property="twitter:title" content={site.title} />
      {site.description ? (
        <meta property="twitter:description" content={site.description} />
      ) : (
        ''
      )}
      <meta property="twitter:image" content={`https://${site.url}`} />
      <link rel="canonical" href={`https://${site.url}`} />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;700&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  );
}
export default Head;
